enum ContextualMenuItemType {
	SetAsTemplate = 'SetAsTemplate',
	RemoveTemplate = 'RemoveTemplate',
	Download = 'Download',
	Delete = 'Delete',
	Update = 'Update',
	Share = 'Share',
	ShareWithUser = 'ShareWithUser',
	Edit = 'Edit',
	PublicationSaveAs = 'PublicationSaveAs',
	ProposalNoSaveAs = 'ProposalNoSaveAs',
	Rename = 'Rename',
	EditCoverImage = 'EditCoverImage',
	DeleteFromAsp = 'DeleteFromAsp',
	Archive = 'Archive',
	CheckForUpdate = 'CheckForUpdate',
	CreateProposal = 'CreateProposal',
	CreateCustomizedProposal = 'CreateCustomizedProposal',
}

export {
	ContextualMenuItemType,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ContextualMenu/constants.ts